import { z } from 'zod';

export const TSDSimulatorAcceptedPayloadSchema = z.object({
  crn: z.string().optional(),
  mrn: z.string().optional(),
  frn: z.string().optional(),
  businessValidationType: z.string().min(1, 'Business validation type is required'),
  status: z.string().min(1, 'Status is required'),
});

export type TSDSimulatorAcceptedPayload = z.infer<typeof TSDSimulatorAcceptedPayloadSchema>;

export const TSDSimulatorPNLinkingResultPayloadSchema = z.object({
  status: z.enum(['04', '05']),
});

export type TSDSimulatorPNLinkingResultPayload = z.infer<typeof TSDSimulatorPNLinkingResultPayloadSchema>;

export const TSDSimulatorWriteOffPayloadSchema = z.object({
  notificationStage: z.enum(['01', '02', '03']),
  startOfTemporaryStorage: z.coerce.date().optional(),
  endOfTemporaryStorage: z.coerce.date().optional(),
  status: z.enum(['02', '12']),
  statusReason: z.string().min(1, 'Status reason is required'),
  grossMassDeclared: z.string().optional(),
  grossMassWrittenOff: z.string().optional(),
  numberOfPackagesDeclared: z.string().optional(),
  numberOfPackagesWrittenOff: z.string().optional(),
});

export type TSDSimulatorWriteOffPayload = z.infer<typeof TSDSimulatorWriteOffPayloadSchema>;

export const TSDSimulatorActivationPayloadSchema = z.object({
  status: z.enum(['02', '06']),
});

export type TSDSimulatorActivationPayload = z.infer<typeof TSDSimulatorActivationPayloadSchema>;

export const TSDSimulatorStatusUpdatePayloadSchema = z.object({
  status: z.enum(['02', '06', '08', '09', '12', '14']),
  statusReason: z.enum(['03', '04', '05', '06', '07', '08', '09']).optional(),
  notificationDate: z.coerce.date().optional(),
  timerForTemporaryStorage: z.coerce.date().optional(),
  remarks: z.string().max(512).optional(),
});

export type TSDSimulatorStatusUpdatePayload = z.infer<typeof TSDSimulatorStatusUpdatePayloadSchema>;
